import { createStore } from 'ccstate'
import { bootstrap } from './bootstrap.tsx'

// globalThis._injected = {
//   sharedCurrentUserState: {
//     currentUser$: {
//       state: 'hasData',
//       data: {
//         isLoggedIn: true,
//         email: 'injected@user.com',
//       }
//     }
//   },
//   sharedLocationState: {
//     pathname$: '/login'
//   },
//   homePageState: {
//     allArticles$: {
//       state: 'hasData',
//       data: {
//         articles: [
//           {
//             id: 1,
//             title: 'fake title',
//             slug: 'fake slug',
//             content: 'This is a randomly generated article content.',
//             excerpt: 'A brief excerpt of the article.',
//             author: 'author',
//             status: 'draft',
//             tags: 'random,generated',
//             featured: false,
//             view_count: 0,
//             created_at: '',
//             published_at: '',
//             updated_at: ''
//           }
//         ]
//       }
//     }
//   },
//   articleReviewFormInstances: {
//     '[["articleId",1]]': {
//       articleId$: 1,
//       rating$: 4
//     }
//   }
// }

const store = createStore()
bootstrap(store)
